import { render, staticRenderFns } from "./TheTopNavigation.vue?vue&type=template&id=6917cd8f&scoped=true&lang=pug"
import script from "./TheTopNavigation.vue?vue&type=script&lang=ts"
export * from "./TheTopNavigation.vue?vue&type=script&lang=ts"
import style0 from "./TheTopNavigation.vue?vue&type=style&index=0&id=6917cd8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6917cd8f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SeasonalHalloween: require('/workspace/portal/hosting/components/seasonal/SeasonalHalloween.vue').default,SeasonalChristmas: require('/workspace/portal/hosting/components/seasonal/SeasonalChristmas.vue').default,LogoPortal: require('/workspace/portal/hosting/components/LogoPortal.vue').default,UserMenu: require('/workspace/portal/hosting/components/UserMenu.vue').default,LsButton: require('/workspace/packages/sharedUI/src/Button/Button.vue').default,LsButtonWrapper: require('/workspace/packages/sharedUI/src/Button/ButtonWrapper/ButtonWrapper.vue').default})
